import { useCallback } from 'react'
import { useSearch } from 'wouter'

import { DropdownMenu } from '@/components/DropdownMenu'
import { Spinner } from '@/components/Spinner'
import { useSearchNavigation } from '@/hooks/useSearchNavigation'
import { useUser } from '@/hooks/useUser'
import { ChevronIcon } from '@/icons'

import s from './Filters.module.css'

type Props = {
  totalCount?: number
  isFetching?: boolean
}

type FilterType = 'personal' | 'organization' | 'shared' | ''

const selectedText = {
  personal: 'Personal',
  organization: 'Work',
  shared: 'Shared',
}

export const Filters = ({ totalCount, isFetching }: Props) => {
  const search = useSearch()
  const { setFilter } = useSearchNavigation()
  const { user } = useUser()

  const handleClick = useCallback(
    (value: FilterType) => {
      setFilter(value)
    },
    [setFilter]
  )

  const selectedValue = new URLSearchParams(search).get('type') as FilterType

  return (
    <div className={s.container}>
      <div>
        <DropdownMenu>
          <DropdownMenu.Trigger>
            <span className={`${s.button} ${s[selectedValue]}`}>
              Show:{' '}
              {selectedValue ? (
                <span className={`${s.selected} ${s[selectedValue]}`}>
                  {selectedText[selectedValue]}
                </span>
              ) : (
                'All'
              )}{' '}
              {ChevronIcon}
            </span>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content position="left" fullWidth>
            <DropdownMenu.Item
              isActive={!selectedValue}
              onClick={() => handleClick('')}
            >
              All
            </DropdownMenu.Item>
            {user?.hasPersonalLinksAccess && (
              <>
                <DropdownMenu.Item
                  isActive={selectedValue === 'personal'}
                  onClick={() => handleClick('personal')}
                >
                  Personal
                </DropdownMenu.Item>
              </>
            )}

            {user?.hasOrgAccess && (
              <DropdownMenu.Item
                isActive={selectedValue === 'organization'}
                onClick={() => handleClick('organization')}
              >
                Work
              </DropdownMenu.Item>
            )}

            <DropdownMenu.Item
              isActive={selectedValue === 'shared'}
              onClick={() => handleClick('shared')}
            >
              Shared with me
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      </div>

      {isFetching ? (
        <Spinner inline />
      ) : !!totalCount ? (
        <div className={s.count}>
          {totalCount} {totalCount === 1 ? 'link' : 'links'}
        </div>
      ) : null}
    </div>
  )
}
